import { Injectable } from '@angular/core';
import { SidebarService } from '../../../shared/sidebar/sidebar.service';
import { Point } from 'geojson';
import { MapElement } from '../../../shared/map/map-element.model';
import { MapService } from '~app/shared/map/map.service';
import { MeasurementTabId } from '~app/element-utils/element-actions/measurements-action/measurements-action.component'
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MeasurementsActionService {

  /** active tab */
  public tabId$ = new Subject<MeasurementTabId>();

  constructor(
    private sidebarService: SidebarService,
    private mapService: MapService,
  ) {

  }

  public openDetails(feature: MapElement<Point>, openTab: MeasurementTabId): void {
    this.mapService.changeCurrentFeature(feature);
    this.tabId$.next(openTab);
    //// static name to avoid circular dependency
    this.sidebarService.requestSidebarPanel('measurements-table', {feature, openTab});
  }
}
